export default {
      id: "arcs_agenda-usage",
      viewBox: "0 0 475 490",
      url: "../dist/images/" + "sprite.svg#arcs_agenda-usage",
      toString: function () {
        return this.url;
      }
    }